import React from 'react'
import { useParams } from 'react-router-dom'
import AgentList from '../../components/agent/AgentList'
import AddAgent from '../../components/agent/AddAgent'

const Agent = () => {
    let { method } = useParams();

    return (
        <>
            {method == "add" && <AddAgent />}
            {method == "list" && <AgentList />}
        </>
    )
}

export default Agent
